import { AppNS } from '../../';
import camelCaseKeys from 'camelcase-keys';

export const prepareResponseData = (data: AppNS.Params): AppNS.Params => {
  return camelCaseKeys(data, { deep: true, exclude: [/^[A-Z]*$/, /^\d{4}-\d{2}-\d{2}$/] });
};
